import React, { useState } from 'react';
import { MenuIcon, XIcon } from '@heroicons/react/outline';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import ico_instagram from "../assets/icons/ico_instagram.svg"
import ico_facebook from '../assets/icons/ico_facebook.svg'
import ico_youtube from '../assets/icons/ico_youtube.svg'
import logo_dabio from '../assets/logos/logo_dabio.svg'
import {
    faYoutube,
    faFacebookF,
    faTwitter
} from "@fortawesome/free-brands-svg-icons";

const Header = () => {

    const [nav, setNav] = useState(false)
    const handleClick = () => setNav(!nav)

    const handleClose = () => setNav(!nav)

    return (
        <div className=' w-full h-[130px] absolute drop-shadow-lg lg:pr-20 z-30 pointer-events-none'>
            <div className='flex justify-between items-center w-full h-full relative'>
                <div className="bg-[#002E0F] z-20 xl:h-full lg:h-[80%] md:h-[70%] sm:h-[60%] h-[40%] xl:w-[30rem] lg:w-[35%] md:w-[40%] sm:w-[40%] w-[40%] absolute top-0 left-0 rounded-br-[4.6rem]">
                    <a href="/"><img loading="lazy" className="pointer-events-auto object-contain pl-5 lg:pt-8 md:pt-4 sm:pt-4 pt-4 pr-11" src={logo_dabio}></img></a>
                </div>
              
                    <div
                        className=" absolute right-0 lg:mr-20 md:mr-10 sm:mr-5 mr-5 top-0 lg:mt-10 md:mt-10 sm:mt-5 mt-5"
                    >
                        <a href="https://www.instagram.com/biodiversidadynegocios/" target="_blank" className="pointer-events-auto inline-flex mr-5 lg:w-16 md:w-10 sm:w-10 w-10 items-center justify-center">
                            <img loading="lazy" src={ico_instagram} alt="Twitter"></img>
                        </a>
                        <a href="https://www.facebook.com/biodiversidadynegociosgiz/" target="_blank" className="pointer-events-auto inline-flex mr-5 lg:w-16 md:w-10 sm:w-10 w-10 items-center justify-center">
                            <img loading="lazy" src={ico_facebook} alt="Facebook"></img>
                        </a>
                        <a href="https://www.youtube.com/channel/UC7Y1zprSXgbPGaCvfFOPEQA" target="_blank" className="pointer-events-auto inline-flex lg:w-16 md:w-10 sm:w-10 w-10 items-center justify-center">
                            <img loading="lazy" src={ico_youtube} alt="Youtube"></img>
                        </a>
                    </div>
            
            </div>

          
        </div>
    );
}

export default Header;